import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { resolve } from 'inversify-react';
import autobind from 'autobind-decorator';

import { ToastNotifications } from 'src/core/ui/toast';
import { ObjectUtils } from 'src/core/utils/object';
import { ControllerProps } from 'src/router';
import { DialogService } from 'src/core/services/ui/dialog.service';
import { RoleListView } from './role-list.view';
import { RoleListDataService } from './role-list.data';

@observer
export class RoleListController extends React.Component<ControllerProps<any>, any> {
    @observable
    protected dataService: RoleListDataService;

    @resolve
    protected dialogService: DialogService;

    @resolve
    protected toast: ToastNotifications;

    public constructor(props) {
        super(props);
        this.dataService = RoleListDataService.make();
    }

    public componentDidMount() {
        this.loadData();
    }

    @autobind
    protected onItemDoubleClicked(item: RoleSummary) {
        this.props.history.push(`/general/roles/${item == null ? 'new' : item.id}`);
    }

    @autobind
    protected loadData() {
        
		this.props.setBusy(true);
		this.dataService.addFilter('isRole', 'eq', true);
		this.dataService.addFilter('isDeleted', 'eq', false);
        this.dataService.addSorting('displayName', 'asc', true);
        this.dataService.load(query => query)
             .then(() => this.props.setBusy(false))
            .catch(error => {
                this.props.setBusy(false);
                this.toast.showToast('Request failed', ObjectUtils.parseError(error), 'error');
            });
    }

    public render() {
        return (
            <RoleListView
                model={this.dataService}
                setBusy={this.props.setBusy}
                 onItemDoubleClicked={this.onItemDoubleClicked}
                  {...this.props} />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/general/roles/list/role-list.controller.tsx